<template>
  <div id="the-app">
    <div v-if="route.page === 'preview.home'">
      <PreviewHome :data="data"/>
    </div>
    <div v-else-if="route.page === 'preview.banner'">
      <PreviewBanner :data="data"/>
    </div>
    <div v-else-if="route.page === 'preview.checkin_options'">
      <preview-checkin-options :data="data"/>
    </div>
    <div v-else-if="route.page === 'preview.privacy'">
      <preview-privacy :data="data"/>
    </div>
    <div v-else-if="route.page === 'preview.popup'">
      <preview-popup :data="data"/>
    </div>
    <div v-else-if="route.page === 'preview.pricelist'">
      <preview-price-list :data="data"/>
    </div>
    <div v-else-if="route.page === 'app.popup.welcome'">
      <app-native-popup-welcome :data="data"/>
    </div>
    <div v-else-if="route.page === 'app.popup.fixed'">
      <app-native-popup-fixed :data="data"/>
    </div>
  </div>
</template>


<script>
import PreviewHome from "@/domain/preview/PreviewHome.vue";
import PreviewBanner from "@/domain/preview/PreviewBanner.vue";
import PreviewCheckinOptions from "@/domain/preview/PreviewCheckinOptions.vue";
import PreviewPrivacy from "@/domain/preview/PreviewPrivacy.vue";
import PreviewPopup from "@/domain/preview/PreviewPopup.vue";
import AppNativePopupWelcome from "@/domain/appNative/AppNativePopupWelcome.vue";
import AppNativePopupFixed from "@/domain/appNative/AppNativePopupFixed.vue";
import PreviewPriceList from "@/domain/preview/PreviewPriceList.vue";

export default {
  name: 'IFrameRouter',
  components: {
    PreviewPriceList,
    AppNativePopupFixed,
    AppNativePopupWelcome,
    PreviewPrivacy,
    PreviewCheckinOptions,
    PreviewBanner,
    PreviewHome,
    PreviewPopup
  },
  props: {
    data: {
      type: Object,
      required: false
    },
    route: {
      type: Object,
      required: false
    }
  }
}
</script>
